import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from 'helpers/LocationHelper';

import ReportApi from 'api/report';
import DataForm from 'components/ui/DataForm';

const ReportFilters = ({ reportId, disabled }) => {
  const history = useHistory();
  const queryParams = useQueryParams();

  const { t } = useTranslation();
  const { data } = useQuery(['report', reportId], () => ReportApi.get(reportId));

  const report = data;

  if (!report) {
    return null;
  }

  const filterForm = report.filter_form || {};

  if (!filterForm.schema) {
    return null;
  }

  filterForm.schema.title = '';
  filterForm.schema.description = '';
  filterForm.formData = queryParams;

  const onSubmit = data => {
    const formData = data.formData;
    Object.keys(formData).forEach(key => (formData[key] === undefined ? delete formData[key] : {}));

    history.push({
      pathname: history.pathname,
      search: '?' + new URLSearchParams(formData).toString(),
    });
  };

  return (
    <DataForm {...filterForm} disabled={disabled} onSubmit={onSubmit}>
      <div className="text-right">
        <button type="submit" disabled={disabled} className="btn mt-4 form-control btn-primary">
          {t('keys.filter')}
        </button>
      </div>
    </DataForm>
  );
};

export default ReportFilters;
